import { IGenericGalleryContent } from "./content";

export interface IGuestContent extends IGenericGalleryContent {
  guestTheme: string;
  guestUsername: string;
}

export interface IValidatedGuest {
  presentationId: number;
  token: string;
  presentationName: string;
  guestId: number;
}
export interface IGuestPinFormValues {
  pin: string;
  zone: string;
  
}

export interface IGuestScreenValues {
  code: string;
}

export interface IPresentationInfo {
  presentationId: number;
  presentationName: string;
}
  
export interface IScreenInfo{
  id: number;
  url: string;
  code: string;
  screenTypeId: number;
  fingerPrint: string;
  qrDataType: string
  }

var screenType = {
  Single: 1,
  Template: 2,
  Dinamic: 3,
};
export default screenType;
